import * as React from "react";
import { createRoot } from "react-dom/client";
import { Splash } from "~/components/splash";
import { i18nInitPromise } from "~/lib/i18n";

const App = React.lazy(async () => {
  const [module] = await Promise.all([
    import("~/routes"),
    new Promise((resolve) => setTimeout(resolve, 1000)),
  ]);
  return { default: module.App };
});

const shouldEnableMocks = (env = import.meta.env) => {
  return (
    (env.VITE_ENABLE_MOCKS as unknown as string) === "true" &&
    // prevent mocks in PROD regardless of VITE_ENABLE_MOCKS
    !env.PROD
  );
};

const startMocks = async () => {
  const { worker } = await import("~/mocks/browser");
  return worker.start({
    onUnhandledRequest: "bypass",
  });
};

const renderApp = () => {
  const root =
    document.getElementById("root") ||
    document.body.appendChild(document.createElement("div"));
  createRoot(root).render(
    <React.Suspense fallback={<Splash progressiveBranded />}>
      <App />
    </React.Suspense>,
  );
};

export const startApp = async (env = import.meta.env) => {
  await i18nInitPromise;
  if (shouldEnableMocks(env)) await startMocks();
  renderApp();
};

await startApp();
